import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {patchProject} from "../project/one-project/projectAction";
import ExitButton from "../buttons/ExitButton";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import Counter from "../counter/Counter";
import {GreenButton} from "../buttons/ButtonStyles";
import {FunctionalModal} from "./FunctionalModal";
import ToggleSwitchButton from "../buttons/ToggleSwitchButton";

const CounterModal = ({
                          setOpenEditModal,
                          property
                      }) => {

    const budget = "budget"
    const dispatch = useDispatch();
    const {
        realBudget,
        realTimeSpent,
        estimatedBudget,
        estimatedTimeSpent,
        id,
        isTimeSpentOptional,
        isBudgetOptional
    } = useSelector(state => state.project)
    const [counterForEstimatedItem, setCounterForEstimatedItem] = useState(property === budget ? estimatedBudget : estimatedTimeSpent)
    const [counterForRealItem, setCounterForRealItem] = useState(property === budget ? realBudget : realTimeSpent)
    const {status: currentUserStatus} = useSelector(state => state.currentUser)
    const [names, setNames] = useState({title: "", property: "", estimatedItemLabel: {}, realItemLabel: {}})
    const [isOptional, setIsOptional] = useState()

    useEffect(() => {
        if (property === "budget") {
            setNames({
                title: "Modifier les budgets",
                property: "budgets",
                estimatedItemLabel: {label: "Budget prévisionnel", name: "estimatedBudget"},
                realItemLabel: {label: "Budget effectif", name: "realBudget"},
            })
        } else {
            setNames({
                title: "Modifier les temps",
                property: "temps",
                estimatedItemLabel: {label: "Temps prévisionnel", name: "estimatedTimeSpent"},
                realItemLabel: {label: "Temps passé", name: "realTimeSpent"},
            })

        }

    }, [property])

    useEffect(() => {
        if (property === "budget") {
            setIsOptional(isBudgetOptional)
        } else {
            setIsOptional(isTimeSpentOptional)

        }
    }, [isBudgetOptional, isTimeSpentOptional, property])

    const [selectedOption, setSelectedOption] = useState({})

    const handleChange = (e) => {
        const {name, value} = e.target
        if (name.includes("estimated")) {
            if (!value) {
                setCounterForEstimatedItem(0)
            } else {
                setCounterForEstimatedItem(parseInt(value))
                setSelectedOption(state => ({
                    ...state,
                    [name]: parseInt(value)
                }))

            }
        } else {
            if (!value) {
                setCounterForRealItem(0)
            } else {
                setCounterForRealItem(parseInt(value))
                setSelectedOption(state => ({
                    ...state,
                    [name]: parseInt(value)
                }))
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (currentUserStatus === 200) {
            await dispatch(patchProject(id, selectedOption))
            setOpenEditModal(false)
        }
    }

    const handleCount = (property, action) => {
        let value
        if (property.includes("budget")) {
            value = 100
        } else {
            value = 1
        }
        if (property.includes("estimated")) {
            if (action === "add") {
                setCounterForEstimatedItem(counterForEstimatedItem + value)
                setSelectedOption(state => ({
                    ...state,
                    [property]: counterForEstimatedItem + value
                }))
            } else if (action === "subtract") {
                setCounterForEstimatedItem(counterForEstimatedItem - value)
                setSelectedOption(state => ({
                    ...state,
                    [property]: counterForEstimatedItem - value
                }))
            }
        } else {
            if (action === "add") {
                setCounterForRealItem(counterForRealItem + value)
                setSelectedOption(state => ({
                    ...state,
                    [property]: counterForRealItem + value
                }))
            } else if (action === "subtract") {
                setCounterForRealItem(counterForRealItem - value)
                setSelectedOption(state => ({
                    ...state,
                    [property]: counterForRealItem - value
                }))
            }
        }
    }


    const closeUpdate = () => {
        setOpenEditModal(false)
    }
    const toggleChange = () => {
        setIsOptional(!isOptional)
        if (property === 'budget') {
            setSelectedOption({isBudgetOptional: !isOptional})
        } else {
            setSelectedOption({isTimeSpentOptional: !isOptional})
        }
    }
    const displayModal = () => {
        return (
            <Modal>
                <NameSection>
                    <h1> {names.title} </h1>
                    <ExitButton
                        closeUpdate={closeUpdate}
                    />
                </NameSection>
                <Container>
                    <Form id={"edit-counter-form"} onSubmit={handleSubmit}>
                        <div className={"flex-row ai-center gap-05"}>
                            <p> {names.property === "budgets" ? "Avec budget" : "Avec temps passé"} </p>
                            <ToggleSwitchButton
                                onChange={toggleChange}
                                name={names.property}
                                checked={!isOptional}/>
                        </div>
                        {!isOptional &&
                        <>
                            <p> Cliquez ou indiquez directement les {names.property} que vous
                                voulez allouer </p>
                            <CountersContainer>
                                <CounterContainer>
                                    <label
                                        htmlFor={names.estimatedItemLabel.label}> {names.estimatedItemLabel.label}
                                    </label>
                                    <Counter
                                        counter={counterForEstimatedItem}
                                        handleChange={handleChange}
                                        changeCount={handleCount}
                                        name={names.estimatedItemLabel.name}
                                    />
                                </CounterContainer>
                                <CounterContainer>
                                    <label htmlFor={names.realItemLabel.label}> {names.realItemLabel.label} </label>

                                    <Counter
                                        counter={counterForRealItem}
                                        handleChange={handleChange}
                                        changeCount={handleCount}
                                        name={names.realItemLabel.name}
                                    />
                                </CounterContainer>
                            </CountersContainer>
                        </>
                        }

                        <Button form='edit-counter-form' type="submit">
                            <h6> Modifier </h6>
                        </Button>
                    </Form>
                </Container>
            </Modal>
        )
    }
    return (
        <FunctionalModal setOpen={setOpenEditModal} component={displayModal()}/>
    )
}
const Modal = styled(BaseModal)`
  justify-content: space-between;
  width: 95%;
  height: 500px;
  padding: 2em 2em;
  position: fixed;
  gap: 1em;
  
  @media (min-width: 500px) {
    width: 500px;
    left: 0;
    right: 0;
    margin-left: auto ;
    margin-right: auto;
    height: 350px;
  }
  
`

const CounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`

const CountersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (min-width: 700px ) {
    flex-direction: row;
  }
`

const NameSection = styled.div`
  display: flex;
  flex-direction: row;

  h1 {
    width: 90%;
  }

  .exit-btn {
    position: absolute;
    top: 5px;
    right: 15px;
  }
`
const Container = styled.div`
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;

  p {
    text-align: center;
  }
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 1em;
  height: 100%;
  

  /*  div:first-child {
      display: flex;
      flex-direction: row;
      gap: 1em;
    }*/

`

const Button = styled(GreenButton)`
  width: 10em;
  height: 3em;
`


export default CounterModal;